<template>
	<div class="row">
		<!-- customar project  start -->
		<div v-if="user_can_view_report" class="col-md-12">
			<div class="card">
				<div class="card-body">
					<!-- search form -->
					<SearchForm @toggle-input="toggleInput" @search="getReports">
						<div v-if="position_id == 1 || position_id == 2" class="col-md-2">
							<div class="form-group text-center">
								<label class="form-label" for="prepare_by">Prepare By</label>
								<select
									@change="$store.commit('reports/setIncome', [])"
									v-model="params.prepare_by"
									class="form-select"
									id="prepare_by"
									required
								>
									<option value="">--select--</option>
									<option v-if="user_can_view_zonal_data" value="zone">
										By Zones
									</option>
									<option value="state">By States</option>
									<!-- <option v-if="position_id == 3" value="sen. district">
										By Senatorial District
									</option>
									<option v-if="position_id == 4" value="fed. constituency">
										By Federal Constituencies
									</option>
									<option v-if="position_id == 5" value="state constituency">
										By State Constituencies
									</option>
									<option
										v-if="position_id == 6 || position_id == 7"
										value="lga"
									>
										By L.G.A
									</option> -->
								</select>
							</div>
						</div>
					</SearchForm>

					<div
						v-if="user_is_staff_admin && Object.keys(income).length"
						class="alert alert-warning"
					>
						<strong>
							Please note: This page provides reports submitted by various
							political parties, including FORM EC16D, FORM EC16E, and campaign
							tracking data (FORM EC16F).
						</strong>
						<strong>
							<template v-if="params.prepare_by == 'zone'">
								Reports exclude "NATIONAL" as it does not belong to any specific
								zone.
							</template>
							<template v-if="params.prepare_by == 'state'">
								Reports include "NATIONAL" as it is considered a distinct
								entity.
							</template>
						</strong>
					</div>

					<div v-if="Object.keys(income).length" class="table-responsive">
						<table
							id="data-table"
							class="table table-bordered table-striped mb-0"
						>
							<thead>
								<tr>
									<th>S/N</th>
									<th>POLITICAL PARTY</th>
									<th>TYPE OF ELECTION</th>
									<th>{{ params.prepare_by.toUpperCase() }}</th>
									<th>TOTAL INCOME</th>
									<th>TOTAL EXPENSES</th>
									<th v-if="user_is_staff_admin">TOTAL TRACKING</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(income, index) in income.data"
									:key="'inc_' + index"
								>
									<td>{{ index + 1 }}.</td>
									<td>{{ income.party }}</td>
									<td>{{ income.position }}</td>
									<td>{{ income.name }}</td>
									<td>{{ income.total_income }}</td>
									<td>{{ income.total_expenses }}</td>
									<td v-if="user_is_staff_admin">
										{{ income.total_tracking }}
									</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<th></th>
									<th></th>
									<th></th>
									<th>TOTAL</th>
									<th>{{ formatMoney(income.total_income) }}</th>
									<th>{{ formatMoney(income.total_expenses) }}</th>
									<th v-if="user_is_staff_admin">
										{{ formatMoney(income.total_tracking) }}
									</th>
								</tr>
							</tfoot>
						</table>
					</div>
					<div v-if="show_alert" class="alert alert-warning">
						<strong
							>Please choose atleast the type of election, prepare by and click
							on the search button!</strong
						>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="col-md-12 alert alert-danger" align="center">
			<strong>You're not allowed to view this page!</strong>
		</div>
		<!-- customar project  end -->
	</div>
</template>
<script>
import SearchForm from "@/components/SearchForm";
import { mapGetters, mapActions } from "vuex";
import Datatable from "@/utils/datatable.js";
import { userHasPermission, userIsStaffAdmin } from "@/utils/permissions";
import Swal from "sweetalert2";

export default {
	components: {
		SearchForm,
	},
	data() {
		return {
			position_id: null,
			show_alert: false,
			params: {
				prepare_by: "",
			},
		};
	},
	computed: {
		...mapGetters({
			income: "reports/getIncome",
		}),
		user_is_staff_admin() {
			return userIsStaffAdmin();
		},
		user_can_view_report() {
			return userHasPermission("income-expenses-report-view");
		},
		user_can_view_zonal_data() {
			return userHasPermission("staff-zonal-data-view");
		},
	},
	methods: {
		...mapActions({
			getIncomeList: "reports/getIncomeList",
		}),

		async getReports(type = null) {
			try {
				// Handle type validation
				if (type) {
					if (typeof type === "object") {
						// Validate election type
						if (!type.elective_position_id) {
							this.highlightError(
								"elective_position_id",
								"Please choose the type of election"
							);
							return;
						}

						// Validate state for non-presidential elections
						if (
							![1, 2].includes(Number(type.elective_position_id)) &&
							!type.state_code
						) {
							this.highlightError("state_code", "Please choose a state");
							return;
						}

						// Validate party if user has permission
						if (this.user_can_view_report && !type.party_id) {
							this.highlightError("party_id", "Please choose a party");
							return;
						}

						// Update params
						this.params = {
							...this.params,
							q: JSON.stringify(type),
							page: null, // Reset pagination
						};
					} else if (typeof type === "string") {
						// Handle pagination
						this.params.page =
							type === "next"
								? this.income.paginator.current_page + 1
								: this.income.paginator.current_page - 1;
					}
				}

				// Reset and fetch data
				this.reset();
				await this.getIncomeList(this.params);

				// Initialize datatable and check limits
				this.$nextTick(() => {
					this.checkLimit();
					Datatable("#data-table");
				});
			} catch (error) {
				console.error("Error in getReports:", error);
				// Consider adding user-friendly error notification here
			}
		},

		highlightError(elementId, message) {
			const element = document.getElementById(elementId);
			if (element) {
				element.style.borderColor = "red";
				alert(message);
			}
		},

		setPrepareBy() {
			this.$store.commit("reports/setIncome", []);

			if (this.position_id == 3) {
				return (this.params.prepare_by = "sen. district");
			}
			if (this.position_id == 4) {
				return (this.params.prepare_by = "fed. constituency");
			}
			if (this.position_id == 5) {
				return (this.params.prepare_by = "state constituency");
			}
			if (this.position_id == 6 || this.position_id == 7) {
				return (this.params.prepare_by = "lga");
			}
		},

		reset() {
			let color = "#ced4da";
			let party_id = document.getElementById("party_id");
			let elective_position_id = document.getElementById(
				"elective_position_id"
			);
			let state_code = document.getElementById("state_code");

			this.show_alert = false;
			this.$store.commit("reports/setIncome", []);

			if (party_id) {
				party_id.style.borderColor = color;
			}

			if (elective_position_id) {
				elective_position_id.style.borderColor = color;
			}

			if (state_code) {
				state_code.style.borderColor = color;
			}
		},

		toggleInput(input) {
			this.position_id = input.value;
			this.setPrepareBy();
		},

		formatMoney(amount) {
			return new Intl.NumberFormat("en-NG", {
				style: "currency",
				currency: "NGN",
			}).format(amount);
		},

		checkLimit() {
			if (!this.user_is_staff_admin) {
				return;
			}

			if (Object.keys(this.income).length <= 0) {
				return;
			}

			let msg = "";

			if (
				parseFloat(this.income.total_expenses) >
				parseFloat(this.income.spending_limit)
			) {
				msg =
					"The expenditure report submitted by the political party is more than the approved spending limit of " +
					this.formatMoney(this.income.spending_limit);
			}

			if (
				!msg &&
				parseFloat(this.income.total_tracking) >
					parseFloat(this.income.spending_limit)
			) {
				msg =
					"The campaign tracking total amount is more than the approved spending limit of " +
					this.formatMoney(this.income.spending_limit);
			}

			if (msg) {
				Swal.fire({
					title: "Over Spending",
					text: msg,
					icon: "error",
					allowOutsideClick: false,
				});
			}
		},
	},
	mounted() {
		this.reset();
		this.show_alert = true;
	},
};
</script>
